package org.lennycodes.hldi.pages.admin

import kotlinx.coroutines.await
import org.lennycodes.hldi.backend.FirebaseService
import org.lennycodes.hldi.backend.collection
import org.lennycodes.hldi.backend.getDocs
import org.lennycodes.hldi.data.Admin
import org.lennycodes.hldi.data.BlogPost
import org.lennycodes.hldi.data.Event
import org.lennycodes.hldi.data.GalleryImage
import org.lennycodes.hldi.data.Milestone
import org.lennycodes.hldi.data.ResourceDocument

object AdminRepository {

    suspend fun getAllAdmins(): List<Admin> {

        return try {

            val ref = collection(
                FirebaseService.db,
                "users"
            )


            val snapshot = getDocs(ref).await()


            val docs = snapshot.docs as Array<dynamic>


            val admins = mutableListOf<Admin>()


            for (doc in docs) {

                val data = doc.data()


                admins.add(
                    Admin(
                        uid = data.uid?.toString() ?: "",
                        fullName = data.fullName?.toString() ?: "",
                        email = data.email?.toString() ?: ""
                    )
                )

            }


            admins


        } catch (e: Throwable) {

            console.error(
                "Loading admins failed: ${e.message}"
            )

            emptyList()

        }

    }
// getting the milestones
suspend fun getAllMilestones(): List<Milestone> {

    return try {

        val milestoneCollection = collection(
            FirebaseService.db,
            "milestones"
        )


        val snapshot = getDocs(milestoneCollection).await()


        val documents = snapshot.docs as Array<dynamic>


        documents
            .map { document ->

                val data = document.data()

                Milestone(
                    id = document.id.toString(),
                    year = data.year?.toString() ?: "",
                    description = data.description?.toString() ?: ""
                )

            }
            .sortedByDescending { milestone ->
                milestone.year.toIntOrNull() ?: 0
            }


    } catch (e: Throwable) {

        console.error(
            "Loading milestones failed: ${e.message}"
        )

        emptyList()

    }

}
    //getting all the events
    // Getting all events
    suspend fun getAllEvents(): List<Event> {

        return try {

            val eventCollection = collection(
                FirebaseService.db,
                "events"
            )


            val snapshot = getDocs(eventCollection).await()


            val documents = snapshot.docs as Array<dynamic>


            documents
                .map { document ->

                    val data = document.data()

                    Event(
                        id = document.id.toString(),
                        title = data.title?.toString() ?: "",
                        date = data.date?.toString() ?: "",
                        location = data.location?.toString() ?: "",
                        description = data.description?.toString() ?: "",
                        registrationUrl = data.registrationUrl?.toString() ?: ""
                    )

                }
                .sortedByDescending { event ->

                    event.date

                }


        } catch (e: Throwable) {

            console.error(
                "Loading events failed: ${e.message}"
            )

            emptyList()

        }

    }
    //get all the images
    suspend fun getGalleryImages(): List<GalleryImage> {
        return try {
            val snapshot = getDocs(
                collection(FirebaseService.db, "gallery")
            ).await()
            val documents = snapshot.docs as Array<dynamic>
            documents.map { document ->
                val data = document.data()   // note: data() is a function call in Firestore JS
                GalleryImage(
                    id = document.id.toString(),
                    url = data.url?.toString() ?: "",
                    title = data.title?.toString() ?: "",
                    category = data.category?.toString() ?: "",
                    storagePath = data.storagePath?.toString() ?: ""
                )
            }
        } catch (e: Throwable) {
            console.error("Loading gallery failed: ${e.message}")
            emptyList()
        }
    }
  // getting all the blog posts
  suspend fun getAllBlogs(): List<BlogPost> {

      return try {

          val blogCollection = collection(
              FirebaseService.db,
              "blogs"
          )


          val snapshot = getDocs(blogCollection).await()


          val documents = snapshot.docs as Array<dynamic>


          documents
              .map { document ->

                  val data = document.data()

                  BlogPost(
                      id = document.id.toString(),
                      title = data.title?.toString() ?: "",
                      content = data.content?.toString() ?: "",
                      author = data.author?.toString() ?: "",
                      date = data.date?.toString() ?: "",
                      category = data.category?.toString() ?: "",
                      imageUrl = data.imageUrl?.toString() ?: ""
                  )

              }
              .sortedByDescending { blog ->
                  blog.date
              }


      } catch (e: Throwable) {

          console.error(
              "Loading blogs failed: ${e.message}"
          )

          emptyList()

      }

  }
       //get all resources
    suspend fun getAllResources(): List<ResourceDocument> {

        return try {

            val resourceCollection = collection(
                FirebaseService.db,
                "resources"
            )

            val snapshot = getDocs(resourceCollection).await()

            val documents = snapshot.docs as Array<dynamic>

            documents
                .map { document ->

                    val data = document.data()

                    ResourceDocument(
                        id = document.id.toString(),
                        title = data.title?.toString() ?: "",
                        category = data.category?.toString() ?: "",
                        description = data.description?.toString() ?: "",
                        fileUrl = data.fileUrl?.toString() ?: "",
                        storagePath = data.storagePath?.toString() ?: "",
                        publishedOn = data.publishedOn?.toString() ?: ""
                    )

                }
                .sortedByDescending { resource ->
                    resource.publishedOn.toIntOrNull() ?: 0
                }

        } catch (e: Throwable) {

            console.error(
                "Loading resources failed: ${e.message}"
            )

            emptyList()

        }

    }
}